import { SupportCode } from './err-code';

export default {
  ...SupportCode,
  // 中文配置
  401: '验证失败',
  400: '参数错误',
  500: '服务错误',
  101301: 'Http错误',
  101401: '文件错误',
  101101: '无工作室，请先创建工作室',
  101102: '更新游戏失败',
  101103: '创建游戏失败',
  101104: '更新用户失败',
  101106: '游戏已存在',
  101107: '生成游戏 ID 和密钥失败',
  101108: '游戏授权失败',
  101109: '无权限创建游戏',
  101110: '游戏不存在',
  101111: '游戏所属的用户角色不存在',
  101112: '用户没有此游戏和工作室权限',
  101601: '创建失败',
  101602: '查找读取状态失败',
  101603: '读取状态更新失败',
  101604: '信息数量超过最大限制',
  101201: '更新工作室基本信息失败',
  101202: '创建会员邀请记录失败',
  101203: '邀请应用程序已存在',
  101204: '工作室不存在',
  101205: '已经在24小时内邀请过同一用户，不允许多次申请',
  101206: '更新邀请时间和用户名失败',
  101207: '主动申请加入工作室的用户将无法通过界面模拟通话',
  101208: '更新已通过的状态失败',
  101209: '新用户未能加入工作室',
  101210: '无法获取当前管理员的游戏编号，或当前管理员不属于此工作室',
  101211: '审批状态流程错误',
  101212: '当前用户身份不是所有者',
  101213: '用户权限提升失败',
  101214: '删除用户权限失败',
  101215: '无法删除当前用户',
  101216: '删除用户失败',
  101217: '该用户没有此工作室权限',
  101218: '该成员已存在于工作室中',
  101219: '邀请用户加入工作室的电子邮件发送失败',
  101220: '存储中间信息失败',
  101221: '通过电子邮件邀请用户加入工作室的密钥无效',
  101222: '通过电子邮件邀请加入工作室的用户与输入用户不一致',
  101223: '通过电子邮件邀请用户加入工作室的密钥无效',
  101225: '电子邮件邀请加入工作室的参数为空',
  101226: '已在审批过程中',
  101227: '所有者只能删除当前工作室成员',
  101228: '只有所有者权限才能删除用户',
  101229: '您只能申请加入一个工作室',
  101230: '对此工作室无权限',
  101231: '更新失败',
  101232: '此用户已经加入了其他工作室',
  101233: '创建工作室失败',
  101234: '创建的工作室超出限制',
  101305: '参数错误',
  101001: '删除自身失败',
  101002: '删除失败',
  101003: '生成内部服务注册密钥失败',
  101004: '生成内部服务注册地址失败',
  101005: '请求生成注册链接接口异常',
  101122: '游戏代号已存在',
  101701: '创建的基本参数无效',
  101702: '创建失败',
  101703: '查找失败',
  101704: '创建失败',
  101705: '创建非法',
  101801: '服务创建失败',
  101802: '用户没有游戏权限',
  101803: '服务已启用',
  101804: '当前状态不是待批准状态',
  101805: '激活服务失败',
  101806: '管理员审批申请失败',
  101807: '已打开的服务关闭失败',
  101808: '服务配置更新失败',
  /* prettier-ignore */
  101809: '用户申请开通服务失败',
  101810: '检测到菜单和服务名称冲突',
  101811: '用户请求的服务不存在',
  101812: '参数不完整，缺少审批页面URL',
  101813: '当前服务已在审批中，请不要再申请',
  101814: '服务正在开通和创建中，服务不存在',
  101815: '此游戏的服务已经开通了！',
  101816: '服务暂时开通，兼容在线数据，此游戏不存在',
  101817: '重试失败的同步权限，失败记录不存在',
  101818: '重试同步失败的权限，解析记录无法获取游戏ID',
  101819: '重试未能同步的权限，这批列表中有异常',
  101820: '重试未能同步的权限，重试失败',
  101821: '重试同步失败的权限，数据更新失败',
  101822: '重试失败的同步权限，此记录已成功重试',
  101823: '重试失败的同步权限，用户UID不能为空',
  101824: '开启和修改服务状态失败，状态值非法',
  101825: '批量创建服务审批失败',
  101826: '当InGame服务激活时，必须先进行服务部署',
  101846: '账户欠费',
  101927: 'InGame服务已激活，触发部署，部署执行失败',
  101928: 'InGame服务已开通，部署失败',
  101929: '部署失败，非InGame服务无法部署',
  101930: '邮件通知运维失败',
  101901: '当前游戏下的环境有同名',
  101902: '环境创建失败',
  101903: '环境创建失败',
  101904: '需要开通的服务ID不在注册服务中',
  101905: '不允许删除游戏默认创建的环境',
  101906: '创建参数无效',
  101917: '创建参数无效，ID不是开通的服务',
  101918: '获取的游戏环境不存在',
  101919: '超出了环境创建的最大数量',
  102001: '当前游戏下的环境有同名',
  102002: '环境创建失败',
  102003: '获取配置失败',
  102004: '删除记录失败',
  102005: '编辑记录未找到',
  102006: '编辑失败',
  102007: '查询关键配置失败',
  102008: '查询键无效',
  102009: '查询键无效',
  102010: '更新配置到Redis失败',
  103201: '权限中心校验权限接口异常',
  103202: '游戏不存在',
  103203: '环境不存在',
  103205: '参数错误',
  103206: 'key参数错误',
  103207: 'guid参数错误',
  103263: '您没有该操作权限，如需使用请联系管理员获取',
  103245: '该用户没有此工作室权限',
  103405: '提交失败, 已经存在认证信息',
  103430: 'Kpi Code填写有误',
  101848: '未完成企业认证',
  200001: '服务异常',
  200002: '参数异常',
  200003: '日期格式化异常',
  200004: '日期无效',
  200005: '工作室id无效',
  103417: '该企业已被认证',
  300000: '客户信息准确性校验失败',
  300001: '客户信息准确性校验失败',
  300006: '客户信息准确性校验失败',
  300004: '证件号码不合法',
  102228: '已经存在相同的环境在待审批或者启用中记录',
  101124: '该游戏名称已存在，无法创建',
  101265: '该工作室名称已存在，无法创建',
  103402: '认证审核中,请勿重复提交',
  103433: '认证审核中,请勿重复提交',
  parameter_custom_error:
    '参数 "{{parameter}}" 的值 "{{errorValue}}" 无效，请检查后重试。',
  parameter_expected: '预期值为"{{expectedValue}}"。',
};
